var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"click":function($event){return _vm.$root.$emit('bv::hide::popover')}}},[(_vm.$route.name != 'chat' && _vm.$route.name != 'chat project' && _vm.$route.name!= 'chatlive')?_c('Navbar'):_vm._e(),_c('router-view',{key:_vm.$route.path,staticClass:"textcolor"}),_c('Window')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }